/******/ (() => { // webpackBootstrap
  var __webpack_exports__ = {};
  Shopify.theme.jsFooter = {
    init: function ($section) {
      this.$section = $section
      Shopify.theme.jsFooter = $.extend(this, Shopify.theme.getSectionData($section));
      gsap.registerPlugin(ScrollTrigger);
      this.sectionSelector = '#' + this.$section.attr('id') + ' .footer__content'
      if ($('[data-check-for-order]').height() > $(window).height() && isScreenSizeLarge())
        this.initTimeline()
    },
    initTimeline() {
      this.timeline = gsap.timeline({
        scrollTrigger: {
          trigger: '[data-check-for-order]',
          start: "bottom bottom",
          end: "+=500px",
          scrub: true,
          markers: false
        }
      })
      this.timeline.set(this.sectionSelector, { yPercent: '-50' })
      this.timeline.to(this.sectionSelector, { yPercent: 0, ease: 'none' })
    },
    handleEvents: function () {
    },
    unload: function ($section) {

    }
  }

  /******/
})()
  ;